import { coreApi } from '../api'
import { DocumentListProps, AttributesProps } from '../documents'

interface ApplicationDocumentsProps {
  inspectionAppraisal: AttributesProps
}

async function fetchData(
  applicationId: string,
): Promise<ApplicationDocumentsProps> {
  const { data: response } = await coreApi.get<DocumentListProps>(
    `/loan/auto-refi/bkf/applications/${applicationId}/documents`,
  )

  function inspectionAppraisalDocument(): AttributesProps {
    const documents = response.data.filter(
      doc => doc.attributes.name === 'appraisal',
    )
    const appraisalDocument = documents[0]

    return {
      name: appraisalDocument?.attributes.name,
      status: appraisalDocument?.attributes.status,
    }
  }

  return {
    inspectionAppraisal: inspectionAppraisalDocument(),
  }
}

export { fetchData }
